import React from 'react';
import { Link } from 'react-router-dom';

const ModernMenuItem = ({ to, label, location }) => {
  const isActive = location.pathname === to;
  
  return (
    <Link 
      to={to} 
      className={`modern-nav-item ${isActive ? 'active' : ''}`}
      style={{ textDecoration: 'none' }}
    >
      {label}
    </Link>
  );
};

const ModernMenuBar = ({ jwtToken, location }) => {
  if (jwtToken === '') return null;

  return (
    <nav className="modern-nav">
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem', justifyContent: 'center' }}>
        <ModernMenuItem to="/" label="Home" location={location} />
        <ModernMenuItem to="/current" label="Current Counts" location={location} />
        <ModernMenuItem to="/today" label="Today" location={location} />
        <ModernMenuItem to="/streaks" label="Streaks" location={location} />
        <ModernMenuItem to="/counters" label="Counters" location={location} />
        <ModernMenuItem to="/goals" label="Goals" location={location} />
        <ModernMenuItem to="/progress" label="Goal Progress" location={location} />
      </div>
    </nav>
  );
};

export default ModernMenuBar;